import type { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAccess } from '../../hooks/useAccess'

export default function AccessRoute({ resource, action = 'read', children }: { resource: string; action?: 'read' | 'write'; children: ReactNode }) {
  const access = useAccess()
  const rights = access.resource(resource)
  if (access.isLoading) return <p role="status">Vérification de votre accès…</p>
  if (!rights[action]) return <p role="alert">Votre accès ne permet pas d’ouvrir cette page.</p>
  return <>{children}</>
}

export function OptimizationEditorRoute({ children }: { children: ReactNode }) {
  const { runId } = useParams()
  const access = useAccess()
  const rights = access.resource('optimization')
  if (access.isLoading) return <p role="status">Vérification de votre accès…</p>
  if (rights.read && !rights.write && runId) return <Navigate to={`/optimization/${encodeURIComponent(runId)}/viewer`} replace />
  return <AccessRoute resource="optimization" action="write">{children}</AccessRoute>
}
